import React from 'react';

import ScrollToTheBottomButton from './ScrollToTheBottomButton/ScrollToTheBottomButton';
import MessagesList from './MessagesList/MessagesList';
import Loader from 'react-simple-loading';

import withStoreMessages from './withStoreMessages';

import './css/Messages.css';
import './css/Messages.mobile.css';

@withStoreMessages
class Messages extends React.Component {

  state = {
    scrollToBottom: false,
    unreadMessages: 0
  }
  messagesRef = React.createRef();

  componentDidMount () {
    this.props.loadMessages();
    this.messagesRef.current.addEventListener('scroll', this.onMessagesContainerScroll);
  }

  componentDidUpdate (prevProps) {
    const { messages: prevMessages } = prevProps;
    const { messages: newMessages } = this.props;
    const hasUnreadMessagesAvailable = newMessages.length &&
      prevMessages.length &&
        newMessages[newMessages.length - 1].timestamp !== prevMessages[prevMessages.length - 1].timestamp;

    if (prevMessages.length !== newMessages.length) {
      if (!document.hidden && !this.state.scrollToBottom) {
        this.scrollMessagesToTheBottom();
      } 
        if (hasUnreadMessagesAvailable) {
          this.setState(prevState => {
            return { scrollToBottom: true, unreadMessages: prevState.unreadMessages + 1 }
          });
        }
      
    }
  }

  scrollMessagesToTheBottom = () => {
    this.messagesRef.current.scrollTop = this.messagesRef.current?.scrollHeight;
  }

  readAllTheWayToTheBottom = () => {
    this.scrollMessagesToTheBottom();
    this.setState({ unreadMessages: 0 });
  }

  onMessagesContainerScroll = () => {
    if ((this.messagesRef.current.scrollHeight - this.messagesRef.current.clientHeight) - this.messagesRef.current.scrollTop > 200) {
      this.setState({ scrollToBottom: true });
    } else {
      this.setState({ scrollToBottom: false, unreadMessages: 0 });
    }
  }
  
  onMessagesChange = (unread) => {
    if (!document.hidden && !this.state.scrollToBottom) {
      this.scrollMessagesToTheBottom();
    } else {
      if (this.messagesRef.current.scrollHeight > this.messagesRef.current.clientHeight) {
        this.setState(prevState => {
          return { scrollToBottom: true, unreadMessages: unread === 0 ? 0 : prevState.unreadMessages + 1 }
        });
      }
    }
  }

  handleScroll = () => {
    const isAtTop = this.messagesRef.current.scrollTop === 0;

    if (isAtTop) {
      this.props.loadPreviousMessages();
    }
  };
  
  render () {
    const { messages, inputAreaHeight, anchors, loadingPreviousMessages, reachedEndOfMessageHistory } = this.props;
    const { unreadMessages, scrollToBottom } = this.state;
    return (
      <div
        id="private-chat-conversation-messages"
        ref={this.messagesRef}
        onScroll={this.handleScroll}
      >
        {!reachedEndOfMessageHistory && loadingPreviousMessages &&
          <div className="message-loader">
            <Loader size="25px" />
          </div>
        }
        {reachedEndOfMessageHistory &&
          <div className="history-end-container">
            <strong className="history-end">
                End Of your chat history
            </strong>
          </div>
        }
        <MessagesList
          anchors={anchors}
          messages={messages}
          onMessagesChange={this.onMessagesChange}
          scrollMessagesToTheBottom={this.scrollMessagesToTheBottom}
          />

        {scrollToBottom && (
          <ScrollToTheBottomButton
            readAllTheWayToTheBottom={this.readAllTheWayToTheBottom}
            unreadMessages={unreadMessages}
            inputAreaHeight={inputAreaHeight}
          />
        )}
      </div>
    );
  }
}

export default Messages;
